module.exports = __webpack_public_path__ + "static/img/role-de.01ea04b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/role-3/role-de.png
// module id = d6S7
// module chunks = 1